import ReactDOM from 'react-dom/client';
import './index.css';
import { createTheme, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import defaultTheme from 'tailwindcss/defaultTheme';
import { PaletteColorOptions, PaletteColor } from '@mui/material/styles';
import { IdpContainer } from './IdpContainer';
import { SnackbarProvider } from './Context/SnackbarContext';
import initializeDataDog from './datadog';
import { bootstrapPendo } from './pendo';

declare module '@mui/material/styles' {
  interface Palette {
    white: PaletteColor;
    grey300: PaletteColor;
    buttonGrey: PaletteColor;
    red: PaletteColor;
  }
  interface PaletteOptions {
    white?: PaletteColorOptions;
    grey300?: PaletteColorOptions;
    buttonGrey?: PaletteColorOptions;
    red?: PaletteColorOptions;
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    white: true;
    grey300: true;
    buttonGrey: true;
    red: true;
  }
}

// allow <ButtonGroup color="neutral">
declare module '@mui/material/ButtonGroup' {
  interface ButtonGroupPropsColorOverrides {
    white: true;
    grey300: true;
    buttonGrey: true;
    red: true;
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    white: true;
    grey300: true;
    buttonGrey: true;
    red: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E01A4'
    },
    secondary: {
      main: '#7f7f7f'
    },
    white: {
      main: '#fff'
    },
    grey300: {
      main: '#FFFFFF'
    },
    buttonGrey: {
      main: '#606060'
    },
    red: {
      main: '#e70600'
    }
  },
  typography: {
    allVariants: {
      fontFamily: ['"Helvetica Neue"', '"Segoe UI"', '"Ariel"', ...defaultTheme.fontFamily.sans].join(','),
      fontSize: '14px'
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    // @ts-expect-error - this isn't in the TS because DataGird is not exported from `@mui/material`
    MuiDataGridPro: {
      styleOverrides: {
        row: {
          '&.Mui-selected': {
            backgroundColor: 'grey',
            color: 'yellow',
            '&:hover': {
              backgroundColor: 'purple'
            }
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'lightgrey'
          },
          '&:hover': {
            backgroundColor: 'lightgrey'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  }
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <SnackbarProvider>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <IdpContainer />
        </LocalizationProvider>
      </ThemeProvider>
    </SnackbarProvider>
  </BrowserRouter>
);

initializeDataDog();
bootstrapPendo();
